<template>
  <div>
    <div
      class="demo-upload-list"
      v-for="(item, index) in uploadList"
      :key="index"
    >
      <template v-if="item.status === 'finished'">
        <img :src="item.response.data.url" />
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
          <Icon
            type="ios-trash-outline"
            @click.native="handleRemove(index)"
          ></Icon>
        </div>
      </template>
      <template v-else>
        <Progress
          v-if="item.showProgress"
          :percent="item.percentage"
          hide-info
        ></Progress>
      </template>
    </div>
    <Upload
      ref="upload"
      :show-upload-list="false"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      multiple
      type="drag"
      :action="url"
      :headers="headers"
      style="display: inline-block;width:100px;"
    >
      <div style="width: 100px;height:100px;line-height: 100px;">
        <Icon type="ios-camera" size="20"></Icon>
      </div>
    </Upload>
    <Modal title="查看图片" v-model="visible">
      <img :src="imgName" v-if="visible" style="width: 100%" />
    </Modal>
  </div>
</template>

<script>
import imageConversion from "image-conversion";
export default {
  name: "UploadPic",
  data() {
    return {
      url: "http://mo.droga.cn/api/upload/image",
      headers: {
        "Authori-zation": "Bearer " + sessionStorage.getItem("token")
      },
      uploadList: [],
      imgName: "",
      visible: false
    };
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
  },
  methods: {
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isLt2M = file.size / 1024 / 1024 < 1; // 判定图片大小是否小于1MB
        if (isLt2M) {
          resolve(file);
        }
        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion
          .compressAccurately(file, 400)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    handleSuccess() {
      this.postImg();
    },
    handleView(item) {
      this.imgName = item.response.data.url;
      this.visible = true;
    },
    handleRemove(index) {
      this.uploadList.splice(index, 1);
      this.postImg();
    },
    postImg() {
      const imageList = [];
      this.uploadList.forEach(item => {
        if (item.response) {
          imageList.push(item.response.data.url);
        }
      });
      this.$emit("getPrescriptionImg", imageList);
    }
  }
};
</script>

<style lang="stylus" scoped>
.demo-upload-list
  display inline-block
  width 100px
  height 100px
  text-align center
  line-height 100px
  border 1px solid transparent
  border-radius 4px
  overflow hidden
  background #fff
  position relative
  box-shadow 0 1px 1px rgba(0,0,0,.2)
  margin-right 4px
.demo-upload-list img
  width 100%
  height 100%
.demo-upload-list-cover
  display none
  position absolute
  top 0
  bottom 0
  left 0
  right 0
  background rgba(0,0,0,.6)
.demo-upload-list:hover .demo-upload-list-cover
  display block
.demo-upload-list-cover i
  color #fff
  font-size 20px
  cursor pointer
  margin 0 2px
</style>
